"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressToString = exports.formatAddressState = exports.convertTextToTitleCase = exports.getLegalEntityName = exports.convertDateToUtcAtMidnight = exports.getDateYear = exports.capitaliseNameString = exports.addDollarSign = void 0;
const addDollarSign = (amount) => {
    if (amount.includes("-")) {
        return `-$${amount.split("-")[1]}`;
    }
    return `$${amount}`;
};
exports.addDollarSign = addDollarSign;
// This function capitalises a name string, including checking if the name has an apostrophe e.g. Callum O'Donnell
const capitaliseNameString = (name) => {
    const capitalisedArr = name
        .toLowerCase()
        .split(" ")
        .map((item) => {
        if (item.includes("'")) {
            const arr = item.toLowerCase().split("'");
            return `${arr[0].toUpperCase()}'${arr[1].charAt(0).toUpperCase()}${arr[1].slice(1)}`;
        }
        return `${item.charAt(0).toUpperCase()}${item.toLowerCase().slice(1)}`;
    });
    return capitalisedArr.join(" ");
};
exports.capitaliseNameString = capitaliseNameString;
const getDateYear = (dateString) => {
    const splitDate = dateString.split(" ");
    return parseInt(splitDate[splitDate.length - 1], 10);
};
exports.getDateYear = getDateYear;
/*
  Returns a Date object with a local timestamp which is the equivalent of midnight UTC time

  Note that our API container is hosted on GCP in the Sydney/Australia timezone, hence, whenever we create a new date in the API and save it to the DB, we are always operating with the Sydney timezone

  For example, Sydney EST equals GMT plus 10 hours, so a date of "21 Oct 2022" would be returned by this function as 2022-10-21T10:00:00.000+10:00, which will then be saved in Mongo as midnight UTC time: 2022-10-21T10:00:00.000+00:00

  Note that during Eastern Daylight Savings Time (EDT), the difference will be 11 hours, but the date saved in Mongo will always be midnight UTC time

  We do this because in BOULEVARD we generally do not care about timestamps - its only the date that matters. We report dates to ASIC and they only care about the date itself (and all dates we send to them should be based on the Sydney timezone)

  For more info on how to interact with dates in BOULEVARD code, please refer to the Engineering documentation in Confluence
*/
const convertDateToUtcAtMidnight = (date) => {
    const dateObject = new Date(date);
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth();
    const day = dateObject.getDate();
    return new Date(Date.UTC(year, month, day, 0, 0, 0));
};
exports.convertDateToUtcAtMidnight = convertDateToUtcAtMidnight;
const getLegalEntityName = (owners, beneficialOwner, companyName, beneficiaryName) => {
    let legalEntityName = "";
    if ((!companyName && beneficialOwner) || (!companyName && !beneficialOwner && !beneficiaryName)) {
        legalEntityName = owners
            .map((owner) => `${owner.firstName} ${owner.middleName ? `${owner.middleName} ` : ""}${owner.lastName}`)
            .join(", ");
    }
    else if (!companyName && !beneficialOwner && beneficiaryName) {
        legalEntityName = `${owners
            .map((owner) => `${owner.firstName} ${owner.middleName ? `${owner.middleName} ` : ""}${owner.lastName}`)
            .join(", ")} ATF ${beneficiaryName}`;
    }
    else if ((companyName && beneficialOwner) || (companyName && !beneficialOwner && !beneficiaryName)) {
        legalEntityName = companyName;
    }
    else if (companyName && !beneficialOwner && beneficiaryName) {
        legalEntityName = `${companyName} ATF ${beneficiaryName}`;
    }
    return legalEntityName;
};
exports.getLegalEntityName = getLegalEntityName;
const convertTextToTitleCase = (text) => !text ? "" : text.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
exports.convertTextToTitleCase = convertTextToTitleCase;
/** Australian addresses show the state in uppercase (for example NSW); other countries use title case. */
const formatAddressState = (state, country) => {
    if (!state?.trim()) {
        return "";
    }
    return country?.toLowerCase() === "australia" ? state.trim().toUpperCase() : (0, exports.convertTextToTitleCase)(state);
};
exports.formatAddressState = formatAddressState;
const formatStreetAddressLine = (line2, street) => [line2, street].map(exports.convertTextToTitleCase).filter(Boolean).join(", ");
const addressToString = (address, isMultipleLines = false, separator = ", ", isPDFFormating = false // using old styles in PDF as per requirement
) => {
    if (!address) {
        return "";
    }
    const { careOf, line2, locality, street, state, postcode, country } = address;
    const localityLine = [(0, exports.convertTextToTitleCase)(locality), (0, exports.formatAddressState)(state, country), postcode]
        .filter(Boolean)
        .join(isPDFFormating ? " " : separator);
    if (isPDFFormating) {
        const lines = [
            careOf ? (0, exports.convertTextToTitleCase)(careOf) : "",
            formatStreetAddressLine(line2, street),
            localityLine,
            country ? (0, exports.convertTextToTitleCase)(country) : "",
        ].filter(Boolean);
        return `${lines.join("\n    ")}\n    `;
    }
    const parts = [
        (0, exports.convertTextToTitleCase)(careOf),
        formatStreetAddressLine(line2, street),
        localityLine,
        (0, exports.convertTextToTitleCase)(country),
    ].filter(Boolean);
    return parts.join(isMultipleLines ? "\n" : separator);
};
exports.addressToString = addressToString;
//# sourceMappingURL=formatting.js.map